"use client"

import { useState } from "react";
import GoodMarkdownParser from "./safeMarkedParser";

interface ExpandableCommentProps {
  content: string;
  limit?: number;
}

const ExpandableComment = ({ content, limit = 50 }: ExpandableCommentProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const words = content.split(/\s+/);
  const isLong = words.length > limit;
  const excerpt = words.slice(0, limit).join(' ') + '...';

  return (
    <div className="w-full">
      <div className={`prose ${isLong ? "-mb-10" : "-mb-6"} prose-sm max-w-none text-slate-700 leading-relaxed whitespace-pre-wrap`}>
        <GoodMarkdownParser content={isExpanded ? content : (isLong ? excerpt : content)} />
      </div>
      
      {isLong && (
        <button 
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-0 translate-y-2.5 text-[10px] mb-3 font-bold uppercase tracking-widest text-blue-600 hover:text-blue-800 transition-colors"
        >
          {isExpanded ? "↑ Show Less" : "↓ Read More"}
        </button>
      )}
    </div>
  );
};

export default ExpandableComment;